module.exports = __webpack_public_path__ + "img/meridiano.72286189.png";